if (process.env.NODE_ENV === 'development') {
	// ---- remoto
	// exports.urlBase = 'http://ec2-3-89-193-197.compute-1.amazonaws.com:3010'
	// exports.socketBase = 'ws://ec2-3-89-193-197.compute-1.amazonaws.com:3010'
	// exports.origin = 'http://localhost:8080'

	// ---- local network
	// exports.urlBase = 'http://192.168.0.5:3010'
	// exports.socketBase = 'ws://192.168.0.5:3010'
	// exports.origin = 'http://192.168.0.5:8080'

	// ---- localhost
	exports.urlBase = 'http://localhost:3010'
	exports.socketBase = 'ws://localhost:3010'
  exports.origin = 'http://localhost:8080'

	// ---- production
	// exports.urlBase = 'http://ec2-3-89-193-197.compute-1.amazonaws.com'
	// exports.socketBase = 'ws://ec2-3-89-193-197.compute-1.amazonaws.com'
  // exports.origin = 'https://launchertech.com'

  exports.username = '2797a5a2-b1bc-4b95-b2c1-04f96fea77ca'
  exports.password = '5a84bac0-a643-40c1-b950-12371b466858'
} else {
	exports.urlBase = 'https://tranquilandia.herokuapp.com'
	// exports.socketBase = 'https://tranquilandia.herokuapp.com'
  exports.origin = 'https://launchertech.com'
}



//////////////////
// WEBPACK FOOTER
// ./config/url.js
// module id = FKvS
// module chunks = 1